export const LOCATIONS = [
  {
    id: "pimple-saudagar",
    name: "Pimple Saudagar",
    tagline: "The Startup Haven",
    shortDescription: "A vibrant coworking hub in the heart of Pimple Saudagar, perfect for startups and freelancers looking for an energetic workspace.",
    fullDescription: "Located in one of Pune's fastest-growing residential and commercial areas, our Pimple Saudagar center offers a dynamic environment tailored for early-stage startups and independent professionals. With excellent connectivity to Hinjewadi IT Park and a thriving local ecosystem, this space is designed to fuel your growth.",
    image: "https://images.unsplash.com/photo-1504297050568-910d24c426d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjb3dvcmtpbmclMjBzcGFjZSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
    address: "Shop 113, First Floor, A-Wing, Sai Vision, Kunal Icon Rd, Pimple Saudagar, Pune 411027",
    coords: { lat: 18.5925265, lng: 73.8015733 },
    placeCid: "8221514137395318064",
    phone: "+91 91797 48353",
    email: "pimplesaudagar@coffice24x7.in",
    seatTypes: [
      { type: "Open Desk", price: "5,999", period: "/month", description: "Flexible hot desk in our open workspace area" },
      { type: "Dedicated Desk", price: "8,499", period: "/month", description: "Your own reserved desk with storage" },
      { type: "Private Cabin", price: "14,999", period: "/month", description: "Enclosed cabin for 1-4 people" },
      { type: "Day Pass", price: "499", period: "/day", description: "Drop in anytime with full access" },
    ],
    amenities: ["High-Speed WiFi", "Meeting Rooms", "24x7 Access", "Power Backup", "Printer & Scanner", "Cafeteria", "Parking", "CCTV Security", "Locker Storage", "Mail Handling"],
    gallery: [
      "https://images.unsplash.com/photo-1504297050568-910d24c426d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjb3dvcmtpbmclMjBzcGFjZSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1703355685952-03ed19f70f51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtZWV0aW5nJTIwcm9vbSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NzZ8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1626187890723-04ce3dbdc42a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb3dvcmtpbmclMjBzcGFjZSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
    ],
    premium: false,
  },
  {
    id: "kalyani-nagar",
    name: "Kalyani Nagar",
    tagline: "Premium Corporate Hub",
    shortDescription: "A premium coworking space in Kalyani Nagar designed for corporate teams and established businesses seeking a prestigious address.",
    fullDescription: "Our Kalyani Nagar center is our flagship premium workspace, situated in one of Pune's most upscale commercial districts. With a sophisticated design, top-tier amenities, and proximity to Koregaon Park and the business district, this space caters to corporate teams, funded startups, and professional service firms.",
    image: "https://images.unsplash.com/photo-1626187777040-ffb7cb2c5450?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3dvcmtpbmclMjBzcGFjZSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
    address: "Marisoft-1, Marisoft IT Tech Park, Marigold Premises, Kalyani Nagar, Pune 411014",
    coords: { lat: 18.5435469, lng: 73.9070935 },
    placeCid: "706695790870804849",
    phone: "+91 91797 48353",
    email: "kalyaninagar@coffice24x7.in",
    seatTypes: [
      { type: "Open Desk", price: "7,999", period: "/month", description: "Premium hot desk with ergonomic seating" },
      { type: "Dedicated Desk", price: "11,999", period: "/month", description: "Reserved desk with premium amenities" },
      { type: "Private Cabin", price: "19,999", period: "/month", description: "Luxury enclosed cabin for 1-6 people" },
      { type: "Day Pass", price: "699", period: "/day", description: "Full-day premium access" },
    ],
    amenities: ["High-Speed WiFi", "Boardroom", "24x7 Access", "Power Backup", "Printer & Scanner", "Pantry & Lounge", "Valet Parking", "CCTV Security", "Locker Storage", "Mail Handling", "Reception Services", "Phone Booth"],
    gallery: [
      "https://images.unsplash.com/photo-1626187777040-ffb7cb2c5450?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3dvcmtpbmclMjBzcGFjZSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1628017974725-18928e8e8211?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtZWV0aW5nJTIwcm9vbSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NzZ8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1727857934741-93f20b9ffe71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxwZW9wbGUlMjB3b3JraW5nJTIwc3RhcnR1cCUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
    ],
    premium: true,
  },
  {
    id: "baner",
    name: "Baner",
    tagline: "Tech Corridor Workspace",
    shortDescription: "Strategically located near IT parks, our Baner center is the ideal base for tech teams and remote workers.",
    image: "https://images.unsplash.com/photo-1703355685952-03ed19f70f51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtZWV0aW5nJTIwcm9vbSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NzZ8MA&ixlib=rb-4.1.0&q=85",
    address: "2nd Floor, Baner Business Park, Baner Road, Pune 411045",
    coords: { lat: 18.5589937, lng: 73.7845232 },
    phone: "+91 91797 48353",
    premium: false,
  },
  {
    id: "viman-nagar",
    name: "Viman Nagar",
    tagline: "Airport Proximity Hub",
    shortDescription: "Minutes from the airport, our Viman Nagar space is perfect for frequent travelers and client-facing businesses.",
    image: "https://images.unsplash.com/photo-1628017974725-18928e8e8211?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtZWV0aW5nJTIwcm9vbSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NzZ8MA&ixlib=rb-4.1.0&q=85",
    address: "1st Floor, Viman Heights, Viman Nagar, Pune 411014",
    coords: { lat: 18.5703877, lng: 73.9133336 },
    phone: "+91 91797 48353",
    premium: false,
  },
  {
    id: "kharadi",
    name: "Kharadi",
    tagline: "East Pune Innovation Lab",
    shortDescription: "Our newest center in the booming Kharadi IT corridor, built for innovative teams scaling fast.",
    image: "https://images.unsplash.com/photo-1626187853752-898f59dc180e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb3dvcmtpbmclMjBzcGFjZSUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
    address: "4th Floor, EON IT Park, Kharadi, Pune 411014",
    coords: { lat: 18.5512763, lng: 73.9416575 },
    phone: "+91 91797 48353",
    premium: false,
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Pravin Pimpale",
    role: "Coworking Member",
    text: "Very comfortable place for all coworkers, I like to be working here, it is a well equipped place.",
    avatar: "PP",
  },
  {
    id: 2,
    name: "Pooja Kambale",
    role: "Coworking Member",
    text: "Great place to work. Highly focused and motivating environment. Competitive pricing, also really insightful events are organised time to time.",
    avatar: "PK",
  },
  {
    id: 3,
    name: "Suraj Jadhav",
    role: "Coworking Member",
    text: "Absolutely love working at coffice24x7! The atmosphere is vibrant, the facilities are top notch and the community is incredibly supportive.",
    avatar: "SJ",
  },
  {
    id: 4,
    name: "Rupal Yadav",
    role: "Coworking Member",
    text: "Have been using coffice since a year now, incredible facilities and the work environment is superb.",
    avatar: "RY",
  },
];

export const WHY_CHOOSE_US = [
  {
    title: "24x7 Access",
    description: "Work on your schedule. Our spaces are open round the clock, every single day of the year.",
    icon: "Clock",
  },
  {
    title: "High-Speed Internet",
    description: "Enterprise-grade WiFi with redundant connections ensures you're always online and productive.",
    icon: "Wifi",
  },
  {
    title: "Meeting Rooms",
    description: "Professional meeting and conference rooms available on-demand for your client calls and team huddles.",
    icon: "Users",
  },
  {
    title: "Prime Locations",
    description: "5+ centers across Pune's top business corridors, always close to where you need to be.",
    icon: "MapPin",
  },
  {
    title: "Flexible Plans",
    description: "From day passes to dedicated desks and private cabins, choose what works for you.",
    icon: "Layers",
  },
  {
    title: "Vibrant Community",
    description: "Join a network of founders, freelancers, and professionals. Grow through collaboration.",
    icon: "Sparkles",
  },
];

export const TEAM_MEMBERS = [
  {
    name: "Arjun Mehta",
    role: "Founder & CEO",
    bio: "A serial entrepreneur with 10+ years in real estate and co-living, Arjun envisioned flexible workspaces that empower India's growing startup ecosystem.",
    image: "https://images.unsplash.com/photo-1758691737644-ef8be18256c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzdGFydHVwJTIwZm91bmRlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NjQ0NzU3Nnww&ixlib=rb-4.1.0&q=85",
    initials: "AM",
  },
  {
    name: "Sneha Patil",
    role: "Community Manager",
    bio: "Sneha brings life to every Coffice center. With a background in event management, she curates networking events and ensures every member feels at home.",
    image: "https://images.unsplash.com/photo-1758691737587-7630b4d31d16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxzdGFydHVwJTIwZm91bmRlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NjQ0NzU3Nnww&ixlib=rb-4.1.0&q=85",
    initials: "SP",
  },
  {
    name: "Vikram Joshi",
    role: "Head of Operations",
    bio: "Vikram ensures every Coffice center runs like clockwork. From infrastructure to member support, he oversees it all with precision.",
    initials: "VJ",
  },
  {
    name: "Meera Nair",
    role: "Marketing Lead",
    bio: "Meera drives Coffice's brand story, digital presence, and partnership strategy. She's passionate about building communities that matter.",
    initials: "MN",
  },
];

export const BLOG_POSTS = [
  {
    id: 1,
    slug: "benefits-of-coworking-spaces",
    title: "Benefits of Coworking Spaces",
    excerpt: "Discover why coworking spaces are becoming the preferred choice for startups, freelancers, and remote teams across India.",
    image: "https://images.unsplash.com/photo-1758876203342-fc14c0bba67c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxwZW9wbGUlMjB3b3JraW5nJTIwc3RhcnR1cCUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
    date: "January 15, 2026",
    readTime: "5 min read",
    author: "Arjun Mehta",
    category: "Insights",
    content: `
The modern workplace is evolving rapidly. Gone are the days when a cubicle in a corporate office was the only option. Coworking spaces have emerged as a powerful alternative that offers flexibility, community, and cost-effectiveness.

**Cost Efficiency**

One of the biggest advantages of coworking is the significant cost savings. Instead of committing to expensive long-term leases, buying furniture, and setting up infrastructure, you get a ready-to-use workspace at a fraction of the cost. For startups and freelancers, this means more capital for growth.

**Networking Opportunities**

Coworking spaces bring together diverse professionals under one roof. From tech founders to creative designers, the networking opportunities are unparalleled. Many successful collaborations and partnerships have started over a coffee break in a shared workspace.

**Productivity Boost**

Studies show that coworking space members report a 74% increase in productivity. The professional environment, combined with the energy of like-minded individuals, creates the perfect conditions for focused work.

**Flexibility**

Need a desk for a day? A cabin for a month? A boardroom for an hour? Coworking spaces offer unmatched flexibility, allowing you to scale up or down as your business evolves. No lock-in periods, no hassle.

**Work-Life Balance**

With 24x7 access, you can work when you're most productive. Whether you're an early bird or a night owl, the space adapts to your rhythm, not the other way around.

At Coffice 24x7, we've designed our spaces to maximize all these benefits while adding our own touch of community and culture.
    `,
  },
  {
    id: 2,
    slug: "how-to-stay-productive-while-working-remote",
    title: "How to Stay Productive While Working Remote",
    excerpt: "Practical tips and strategies to maintain peak productivity when working outside a traditional office environment.",
    image: "https://images.unsplash.com/photo-1670851050245-d861fd433d06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxwZW9wbGUlMjB3b3JraW5nJTIwc3RhcnR1cCUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
    date: "February 2, 2026",
    readTime: "4 min read",
    author: "Sneha Patil",
    category: "Productivity",
    content: `
Remote work has become the norm for millions of professionals. But with freedom comes the challenge of staying focused and productive. Here are our tried-and-tested strategies.

**Create a Dedicated Workspace**

Your environment shapes your mindset. Set up a dedicated work area that signals to your brain it's time to focus. This could be a home office or, better yet, a coworking space where distractions are minimized.

**Time Blocking**

Divide your day into focused blocks. Dedicate specific hours to deep work, meetings, and breaks. Tools like Pomodoro timers can help maintain intense focus in short bursts.

**Minimize Digital Distractions**

Turn off non-essential notifications during work hours. Use apps like Focus mode or website blockers to keep social media at bay during deep work sessions.

**Regular Breaks**

Counterintuitively, taking regular breaks actually boosts productivity. Step away from your screen every 90 minutes. A quick walk, stretch, or coffee break recharges your mental energy.

**Set Clear Boundaries**

Communicate your work hours to family, friends, and even yourself. When work time ends, close the laptop and step away. Burnout is the enemy of sustained productivity.

**Leverage Community**

Working alone can be isolating. Coworking spaces solve this by providing a community of professionals around you, creating accountability and social interaction without the formality of a corporate office.

At Coffice 24x7, we've seen members transform their productivity by simply changing their environment.
    `,
  },
  {
    id: 3,
    slug: "why-pune-is-a-startup-hub",
    title: "Why Pune is a Startup Hub",
    excerpt: "Explore the factors that make Pune one of India's most exciting destinations for startups and tech companies.",
    image: "https://images.unsplash.com/photo-1727857934778-06d7831a6115?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwZW9wbGUlMjB3b3JraW5nJTIwc3RhcnR1cCUyMG9mZmljZXxlbnwwfHx8fDE3NzY0NDc1NTh8MA&ixlib=rb-4.1.0&q=85",
    date: "February 10, 2026",
    readTime: "6 min read",
    author: "Arjun Mehta",
    category: "Ecosystem",
    content: `
Pune has quietly emerged as one of India's top startup ecosystems, rivaling Bangalore and Hyderabad. Here's why founders are increasingly choosing Pune as their base.

**Talent Pool**

Home to prestigious institutions like COEP, Symbiosis, and multiple engineering colleges, Pune produces a steady stream of skilled graduates. The IT corridor (Hinjewadi, Kharadi, Baner) houses major tech companies, creating a deep pool of experienced professionals.

**Cost of Living**

Compared to Bangalore and Mumbai, Pune offers significantly lower costs for office space, housing, and daily living. This translates to lower burn rates for startups, extending their runway and improving their chances of success.

**Quality of Life**

Pune's pleasant climate, cultural heritage, vibrant food scene, and proximity to hill stations make it an attractive destination for talent. Happy teams build better products.

**Growing Ecosystem**

Venture capital firms, angel networks, accelerators, and incubators have established strong presences in Pune. Events like Pune Startup Fest and TiE Pune provide regular platforms for founders to connect and learn.

**Infrastructure**

Modern commercial spaces, improving public transport, and excellent highway connectivity to Mumbai make Pune increasingly accessible and business-friendly.

**The Coffice Advantage**

At Coffice 24x7, we're proud to be part of Pune's startup story. With 5+ centers across the city, we provide the infrastructure that enables founders to focus on what matters most: building great products.
    `,
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Locations", href: "/locations" },
  { label: "About", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];
